import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/index.css'
import './assets/rem.js'
import Cookies from 'js-cookie'
import axios from 'axios'
import Router from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import PageColumn from './components/Column.vue'
import 'vant/lib/index.css';
Vue.component(PageColumn.name, PageColumn)
Vue.config.productionTip = false
Vue.prototype.$cookies = Cookies
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
console.log(process.env)
Vue.prototype.$http=axios.create({
	// baseURL:'http://139.9.173.83/web/api'
	baseURL:process.env.VUE_APP_API_URL||'/web/api', 
})
Vue.use(ElementUI, { locale })
import BottomContent from './components/bottomContent'
Vue.component('p-bottom',BottomContent)
// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面meta */
//   if(to.meta.content){
//     let head = document.getElementsByTagName('head');
//     let meta = document.createElement('meta');
//     meta.content = to.meta.content;
//     head[0].appendChild(meta)
//   }
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
//   next()
// });
// 
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
